import { render, staticRenderFns } from "./Articlelist.vue?vue&type=template&id=1f179bbd&scoped=true&"
import script from "./Articlelist.vue?vue&type=script&lang=js&"
export * from "./Articlelist.vue?vue&type=script&lang=js&"
import style0 from "./Articlelist.vue?vue&type=style&index=0&id=1f179bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f179bbd",
  null
  
)

export default component.exports